import { ParentProps, Show } from "solid-js";
import { requireDraggableContext } from "../DraggableContext";
import { Portal } from "solid-js/web";

export default function Helper(props: ParentProps) {
    const ctx = requireDraggableContext();

    function initElement(el: HTMLDivElement) {
        ctx.setHelperElement(el);
    }

    return <Show when={ctx.isDragging()}>
        <Portal ref={initElement} >
            {props.children}
        </Portal>
    </Show>
}
